// import { useSelector } from "react-redux";
// import { useEffect } from "react";
// import { RootState } from "../store/store";


// export function ThemeSync() {
//   // const theme = useSelector((state: RootState) => state.layout.themeApp);
//   const theme = 'b10'

//   useEffect(() => {
//     document.documentElement.setAttribute("data-theme", theme);
//   }, [theme]);

//   return null;
// }


import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { loadThemeCss } from "../utils/ultis";
import { setTheme } from "../store/reducers/appCommonSlice";


export function ThemeProvider()
{
  const dispatch = useDispatch();

  useEffect(() =>
  {
    async function initTheme()
    {
      const userTheme = localStorage.getItem("user-theme-vmrs");

      if (userTheme)
      {
        loadThemeCss(userTheme);
      } else
      {
        try
        {
          const res = await fetch("/themes/manifest.json", {
            cache: "no-cache",
          });
          const manifest = await res.json();
          const defaultTheme = manifest.active

          dispatch(setTheme(defaultTheme));

        } catch (error)
        {
          console.error("Failed to load manifest", error);
        }
      }
    }

    initTheme();
  }, [dispatch]);

  return null;
}
